export default function Legal() {
  return (
    <div className="page narrow prose-page">
      <div className="page-head"><p className="kicker">Información legal</p><h1>Aviso legal y privacidad</h1></div>
      <h3>Titular</h3>
      <p>Kanel Bakery — repostería artesanal por encargo, Madrid (España). Datos fiscales pendientes de completar.</p>
      <h3>Pedidos y entregas</h3>
      <p>Todos los productos se elaboran por encargo. La confirmación definitiva del pedido (disponibilidad de fecha y forma de pago) se realiza por WhatsApp o teléfono tras recibir la solicitud. Al tratarse de productos perecederos y personalizados, las cancelaciones deben comunicarse con la antelación que se indique al confirmar.</p>
      <h3>Alérgenos</h3>
      <p>Nuestros productos pueden contener gluten, lácteos, huevo, frutos secos y soja, y se elaboran en un obrador donde se manipulan estos alérgenos. Si tienes una alergia, indícalo en las notas del pedido antes de confirmar.</p>
      <h3>Protección de datos</h3>
      <p>Los datos que facilitas (nombre, teléfono, email y dirección) se usan únicamente para gestionar y entregar tu pedido y comunicarnos contigo. No se ceden a terceros salvo lo imprescindible para la entrega. Puedes solicitar el acceso, rectificación o supresión de tus datos escribiéndonos.</p>
      <h3>Cookies</h3>
      <p>Esta web usa almacenamiento local del navegador únicamente para recordar el contenido de tu carrito. No utilizamos cookies de seguimiento publicitario.</p>
    </div>
  );
}
